import React from 'react';
import PropTypes from 'prop-types';

const LineChartUp02Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 1V17H17M5 11.0001L8.5 7.5001L11 10.0001L15.5001 5.5"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

LineChartUp02Icon.propTypes = {
  color: PropTypes.string,
};

export default LineChartUp02Icon;
